import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset window scroll to top whenever the route path changes.
 *
 * React Router (v6) doesn't restore scroll on navigation by default — visitors
 * who scroll halfway down Home and then click "Menu" would otherwise land
 * mid-page on Menu, which feels broken. This wraps every <Route> by living
 * inside the <BrowserRouter>.
 *
 * Hash anchors (e.g. `/menu#cat-pizzas`) are honored: when a hash is present
 * we let the browser jump to the anchor instead of forcing the top.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
